/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.0.0
 */
import { SagaIterator } from 'redux-saga';
import { call, put, select, takeEvery } from 'redux-saga/effects';

import { makeSelectLoggedIn, makeSelectNewsServiceAccessLoggedIn } from '../../pages/PageAuth/selectors/authSelectors';
import { requestSaga } from '../../sagas/requestSaga';
import { stringFormatParams } from '../../utils/stringFormat';
import { API_NOTIFICATION, API_NOTIFICATION_ACCOUNT, API_NOTIFICATION_SUBSCRIBER } from '../app/Api';
import { getNotificationsFailed, openNotification } from './notificationActions';
import { GET_NOTIFICATIONS_START } from './notificationConstants';
import { TNotificationGetAction } from './types/actionTypes';
import { ENotificationPlace, INotification } from './types/notificationTypes';

export function* getNotificationsSaga({ payload }: TNotificationGetAction): SagaIterator {
    try {
        const loggedIn = yield select(makeSelectLoggedIn());
        const isNewsServiceUserLoggedIn = yield select(makeSelectNewsServiceAccessLoggedIn());
        if (!loggedIn || isNewsServiceUserLoggedIn) {
            return;
        }

        let url = API_NOTIFICATION;
        if (payload.place === ENotificationPlace.accountId) {
            const clientId = payload.params?.clientId;
            url = stringFormatParams(API_NOTIFICATION_ACCOUNT, { clientId });
        } else if (payload.place === ENotificationPlace.subscriberId) {
            const subscriberId = payload.params?.subscriberId;
            url = stringFormatParams(API_NOTIFICATION_SUBSCRIBER, { subscriberId });
        }
        const list: INotification[] = yield call(requestSaga, url, 'GET');

        const loggedInNow = yield select(makeSelectLoggedIn());
        if (!loggedInNow) {
            return;
        }

        // для карточек нужно обновлять нотификацию
        if (payload.place === ENotificationPlace.accountId || payload.place === ENotificationPlace.subscriberId) {
            yield put(openNotification(list && list.length ? list : [], payload.place));
        } else if (list && list.length) {
            yield put(openNotification(list, payload.place));
        }
    } catch (error) {
        yield put(getNotificationsFailed({ place: payload.place, message: error as string }));
    }
}

export function* notificationSagas() {
    yield takeEvery(GET_NOTIFICATIONS_START, getNotificationsSaga);
}
